import { render, staticRenderFns } from "./myButton.vue?vue&type=template&id=8b5d9782&scoped=true&"
import script from "./myButton.vue?vue&type=script&lang=js&"
export * from "./myButton.vue?vue&type=script&lang=js&"
import style0 from "./myButton.vue?vue&type=style&index=0&id=8b5d9782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5d9782",
  null
  
)

export default component.exports